import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';

// Fetch environment config before bootstrapping the application
fetch('/assets/env.json')
  .then((res) => res.json())
  .then((env) => {
    // Set the environment config in window object so EnvService can access it
    (window as any).__env = env;
    
    // Enable production mode if needed
    if (env.production === true) {
      enableProdMode();
    }
    
    // Bootstrap the Angular application
    platformBrowserDynamic()
      .bootstrapModule(AppModule)
      .catch(err => console.error(err));
  })
  .catch(err => console.error('Error loading environment config:', err));